import {AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {QuestionInput} from '../question-input';
import {SpeechRecognitionService} from "../../service/SpeechRecognitionService.service";
import {BrowsersDetectionService} from "../../service/browsersDetection.service";

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
})
export class TextareaComponent extends QuestionInput implements OnInit, AfterViewInit {

  @ViewChild('inputField', {static: true})
  inputField: ElementRef;

  validInput = false;
  isAndroid = false;
  audioIsRecording = false;
  audioCanRecord = false;

  showSearchButton: boolean;
  speechData: string;


  constructor(private zone: NgZone,
              private speechRecognitionService: SpeechRecognitionService,
              private browsersDetection: BrowsersDetectionService) {
    super();
  }

  ngOnInit() {
    this.audioCanRecord = this.speechRecognitionService.checkSupport();
    this.isAndroid = this.browsersDetection.isAndroid();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.questionAnswered.emit(this.question.answer != null);
    });
  }

  valueChange(value) {
    this.questionAnswered.emit(!!value);
    this.validInput = !!value;
  }


  get answer(): any {
    return (this.inputField.nativeElement as HTMLTextAreaElement).value;
  }

  getLength() {
    if (!(this.inputField.nativeElement as HTMLTextAreaElement).value) {
      return '0/' + this.question.answerLength;
    }
    return (this.inputField.nativeElement as HTMLTextAreaElement).value.length + '/' + this.question.answerLength;
  }

  getTitle(){
    let title = '';
    if(this.question.answer){
        title = this.question.answer;
    }

    return title;
  }

  recordAudio() {
    this.audioIsRecording = true;
    this.speechRecognitionService.record()
      .subscribe(
        //listener
        (value) => {
          this.speechData = value;

          this.inputField.nativeElement.value += value + ' ';

        },
        //errror
        (err) => {
          console.log(err);
          // if (err.error == "no-speech") {
          //   console.log("--restatring service--");
          //   this.recordAudio();
          // }
        },
        //completion
        () => {
          this.showSearchButton = true;
          console.log("--complete--");
          //this.recordAudio();
        });
  }

  stopRecording() {
    this.speechRecognitionService.DestroySpeechObject();
    this.audioIsRecording = false;
    this.valueChange(true);
  }

}
